.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  position: relative;

  font: var(--t-label-l);
  border-radius: var(--r-md);
  /* Ровно 1px. В старом CSS было 0.05em = 0.85px — такая граница
     рендерится по-разному на разных плотностях и местами исчезает. */
  border: 1px solid transparent;

  transition:
    background-color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    transform var(--dur-instant) var(--ease-standard);
}

/* Палец, а не курсор: минимальная зона нажатия 44px по обеим осям. */
.s-lg { min-height: 52px; padding-inline: var(--sp-6); }
.s-md { min-height: var(--tap-min); padding-inline: var(--sp-5); }
.s-sm { min-height: 36px; padding-inline: var(--sp-4); font: var(--t-label-m); }

/* У маленькой кнопки высота меньше 44px — добираем невидимой зоной,
   иначе в неё не попасть на ходу. */
.s-sm::before {
  content: '';
  position: absolute;
  inset: -4px;
}

.full { width: 100%; }

.button:active:not(:disabled) { transform: scale(0.98); }

/* Никогда не grayscale: обесцвеченная кнопка читается как «не загрузилось». */
.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Варианты ─────────────────────────────────────────────────────────*/
.v-primary {
  background: var(--c-grad-cta);
  color: var(--c-text-on-accent);
  box-shadow: var(--sh-1);
}

.v-secondary {
  background: var(--c-surface);
  color: var(--c-text-primary);
  border-color: var(--c-border);
}

.v-secondary:hover:not(:disabled) { border-color: var(--c-border-strong); }

.v-ghost { color: var(--c-accent); }
.v-ghost:hover:not(:disabled) { background: var(--c-accent-bg); }

/* Золото участвует в интерактиве только здесь и только обводкой. */
.v-sacred {
  color: var(--c-sacred-bright);
  border-color: var(--c-sacred-dim);
  background: transparent;
}

.v-sacred:hover:not(:disabled) { border-color: var(--c-sacred); }

/*
 * ОПАСНОСТЬ НИКОГДА НЕ ПЕРЕДАЁТСЯ ОДНИМ ЦВЕТОМ.
 *
 * В теме «Багряный обет» акцент и danger оба красные — отличить кнопку
 * «Удалить» от обычной по цвету невозможно. Поэтому у danger всегда есть
 * граница и всегда есть слово; иконка обязательна на уровне вызова.
 * Побочный эффект: это же решает дальтонизм во всех темах сразу.
 */
.v-danger {
  color: var(--c-danger);
  background: var(--c-danger-bg);
  border-color: var(--c-danger);
}

.icon {
  display: inline-flex;
  flex: none;
}

.label { display: inline-flex; }

/* ── Загрузка ─────────────────────────────────────────────────────────*/
.loading .label { opacity: 0; }
.loading .icon { opacity: 0; }

.dots {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}

.dots::after {
  content: '···';
  letter-spacing: 0.15em;
  animation: pulse var(--dur-ritual) var(--ease-standard) infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
